// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EwoP","rootNoMargin":"styles_rootNoMargin__1Z1eH"};